import React from "react";

export class PrivacyPolicyIT extends React.Component {
    render() {
        return (
            <>
                <p>
                    Ultimo aggiornamento: <b>28/01/2025</b>
                    <br />
                    <br />
                </p>
                <p>
                    DH Healthcare GmbH, una società del Gruppo Dedalus, attribuisce grande importanza e intende prestare particolare attenzione alla protezione dei Suoi dati
                    personali e al rispetto della Sua privacy.
                    <br />
                    La presente privacy policy ed informativa rivolta agli utenti del sito web (di seguito "informativa") ha quindi lo scopo di informarla su come vengono trattati
                    i suoi dati personali quando visita un portale DeepUnity PACSonWEB come, ad esempio, secure.pacsonweb.com (di seguito il "sito").
                    <br />A tal proposito,La informiamo che Dedalus Italia S.p.A. agisce in qualità di titolare del trattamento dei Suoi dati personali (di seguito "noi", "ci" e
                    "nostro").
                    <br />
                    <br />
                    Confermiamo espressamente che tutti i dati personali saranno trattati in conformità al Regolamento 2016/679 del 27 aprile 2016 relativo alla protezione delle
                    persone fisiche con riguardo al trattamento dei dati personali. Si tratta di un aspetto importante e pertanto vi invitiamo a dedicare del tempo alla lettura
                    attenta della presente informativa.
                </p>
                <h2>AMBITO DI APPLICAZIONE DELLA PRESENTE INFORMATIVA SULLA PRIVACY</h2>
                <p>La presente informativa sulla privacy si applica</p>
                <ul>
                    <li>
                        a tutti i dati personali raccolti dagli utenti della piattaforma DeepUnity PACSonWEB. Ciò include tutti i medici, dentisti, specialisti, ... che si
                        registrano e utilizzano DeepUnity PACSonWEB attraverso un account, nonché gli utenti non registrati che aprono una richiesta utilizzando il numero di
                        riferimento e la data di nascita.
                    </li>
                    <li>tutti i termini e le condizioni e le altre politiche di DH Healthcare GmbH applicabili ai servizi forniti, </li>
                </ul>
                <p>
                    La presente informativa sulla privacy non si applica ai dati dei pazienti elaborati da DH Healthcare GmbH per conto di ospedali e reparti di radiologia
                    collegati. Ciò include sia i dati medici generati dal reparto di radiologia sia i dati medici messi a disposizione del reparto di radiologia dal paziente stesso
                    tramite la funzionalità di upload. A tale proposito, si rimanda all'informativa sulla privacy del reparto radiologico interessato.
                </p>
                <h2>1. QUALI DATI PERSONALI RACCOGLIAMO?</h2>
                <p>
                    Quando si utilizza il nostro portale, possiamo raccogliere le seguenti categorie di dati personali su di Lei:
                    <br />• dati identificativi (ad esempio, cognome, nome, indirizzo e-mail, nome utente, password, Regione, tipo di dispositivo).
                    <br />• dati professionali (ad esempio, posizione ricoperta, settore di attività, datore di lavoro).
                    <br />• dati tecnici (ad esempio, indirizzo IP, tipo di browser utilizzato, momento dell'accesso al portale ecc.).
                    <br />• qualsiasi dato personale contenuto in qualsiasi corrispondenza che ci venga inviata.
                    <br />
                    <br />
                    Il conferimento dei Suoi dati personali è volontario, ma senza di essi non saremo in grado di fornirLe i servizi e le informazioni da Lei richiesti. Ad esempio,
                    se ci contatta attraverso il sito, dovrà fornirci il Suo indirizzo e-mail per permetterci di risponderLe.
                    <br />
                    <br />
                    In ogni caso, La informeremo quando sarà obbligatorio fornire i Suoi dati personali.
                    <br />
                    <br />
                    Inoltre, se ci fornisce dati personali appartenenti a terzi, si impegna a garantire che tali persone siano state debitamente informate del trattamento dei loro
                    dati personali in conformità con questa policy e, se richiesto, abbiano acconsentito al trattamento dei loro dati personali.
                </p>
                <h2>2. PERCHÉ UTILIZZIAMO I SUOI DATI PERSONALI?</h2>
                <p>
                    La tabella sottostante illustra le finalità per le quali trattiamo i Suoi dati personali e, per ciascuna finalità, la base giuridica dell'operazione di
                    trattamento in questione:
                </p>
                <table>
                    <thead>
                        <tr>
                            <th>FINALITÀ</th>
                            <th>BASE GIURIDICA</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                Registrazione di un account utente con l'implementazione di metodi di autenticazione e autorizzazione sicuri. Ciò include, ad esempio, l'invio di
                                e-mail o messaggi di testo per i protocolli di autenticazione a due fattori;
                            </td>
                            <td>Il trattamento si basa sul consenso dell'utente.</td>
                        </tr>
                        <tr>
                            <td>Invio automatico di e-mail quando un nuovo studio è disponibile per l'utente in DeepUnity PACSonWEB;</td>
                            <td>Il trattamento si basa sul consenso dell'utente.</td>
                        </tr>
                        <tr>
                            <td>Tracciabilità dell'accesso registrato alle informazioni mediche;</td>
                            <td>Il trattamento è necessario per rispettare gli obblighi legali a cui siamo soggetti.</td>
                        </tr>
                        <tr>
                            <td>
                                Fornitura dell'elenco degli utenti registrati agli ospedali che utilizzano DeepUnity PACSonWEB per la distribuzione. Questo elenco comprende solo il
                                nome, il cognome e il numero di identificazione del medico (RIZIV, BIG, ...).
                            </td>
                            <td>Il trattamento si basa sul nostro legittimo interesse a informare i nostri clienti sull'uso dei servizi forniti.</td>
                        </tr>
                        <tr>
                            <td>
                                Rispondere alle richieste e alle domande che Lei può presentare attraverso il sito e, più in generale, gestire il nostro rapporto con i visitatori
                                del sito.
                            </td>
                            <td>Il trattamento viene effettuato per fornirLe il servizio che ci ha richiesto.</td>
                        </tr>
                        <tr>
                            <td>Migliorare i nostri servizi e il nostro sito.</td>
                            <td>
                                Il trattamento viene effettuato in base al nostro legittimo interesse, che consiste nell’ottimizzare i nostri strumenti e soluzioni per soddisfare
                                al meglio i visitatori del nostro sito, clienti e potenziali clienti.
                            </td>
                        </tr>
                        <tr>
                            <td>Rispettare gli obblighi legali e normativi a noi applicabili.</td>
                            <td>Il trattamento è necessario per rispettare gli obblighi legali a cui siamo soggetti.</td>
                        </tr>
                        <tr>
                            <td>Gestire controversie potenziali o effettive con Leio con terzi.</td>
                            <td>
                                Il trattamento viene effettuato in base al nostro legittimo interesse, che comporta la difesa dei nostri interessi, anche attraverso azioni legali.
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Inviare, con mezzi automatizzati (es. e-mail, SMS, MMS, ecc.) e non (es. telefono, posta ordinaria, ecc.), messaggi di marketing e contenuti
                                promozionali relativi alle nostre attività, prodotti e servizi e a quelli delle altre società del gruppo Dedalus (incluse ricerche di mercato,
                                indagini sulla soddisfazione dei clienti, informazioni su webinar ed eventi) (marketing)
                            </td>
                            <td>Il trattamento viene effettuato solo nel caso in cui Lei fornisca uno specifico consenso.</td>
                        </tr>
                        <tr>
                            <td>
                                Trasferimento/Condivisione dei Suoi dati personali con altre società del gruppo Dedalus operanti nel settore biomedico, mediante strumenti
                                automatizzati (es. email, SMS, MMS, ecc.) messaggi di marketing e contenuti promozionali relativi alle loro attività, prodotti e servizi (incluse
                                ricerche di mercato, indagini di customer satisfaction, informazioni su webinar ed eventi) (trasferimento di dati a terzi per loro per finalità di
                                marketing).
                            </td>
                            <td>Il trattamento viene effettuato solo nel caso in cui Lei fornisca un consenso specifico</td>
                        </tr>
                    </tbody>
                </table>
                <p>In ogni caso, Le ricordiamo che non tratteremo i Suoi dati personali per nessun altro scopo incompatibile con le finalità di cui sopra.</p>
                <h2>3. CON CHI CONDIVIDIAMO I SUOI DATI PERSONALI?</h2>
                <p>
                    Nel contesto delle nostre operazioni di trattamento, possiamo comunicare i Suoi dati personali ai seguenti destinatari:
                    <br />• ai nostri fornitori, agenti e appaltatori, nella misura in cui ci assistono nello svolgimento delle finalità di cui alla presente policy (ad esempio,
                    utilizziamo fornitori di servizi IT per archiviare i suoi dati personali per nostro conto).
                    <br />• alle altre società del Gruppo Dedalus in cui ci assistono nello svolgimento delle finalità di cui alla presente policy
                    <br />• ai tribunali competenti, alle autorità pubbliche, alle agenzie governative e alle forze dell'ordine (anche nel caso in cui ci venga richiesto di
                    ottemperare a richieste legali o normative).
                    <br />
                    <br />
                    Indipendentemente dal destinatario, divulgheremo loro solamente i dati personali necessari e solo nella misura in cui vengano soddisfatti gli scopi identificati
                    in questa informativa.
                </p>
                <h2>4. TRASFERIAMO DATI AL DI FUORI DELLO SPAZIO ECONOMICO EUROPEO?</h2>
                <p>
                    Per tutti i Paesi appartenenti allo Spazio Economico Europeo, i dati sanitari personali trattati da DeepUnity PACSonWEB non vengono trasferiti in alcun Paese al di fuori del suddetto spazio.
                </p>
                <p>
                    Qualora i Suoi dati personali vengano trasferiti al di fuori dello Spazio Economico Europeo (“SEE“), ci assicuriamo che il livello di protezione dei Suoi dati
                    personali non sia influenzato negativamente da tali trasferimenti.
                </p>
                <p>Ciò significa specificamente che ciascuno dei trasferimenti previsti si basa almeno su uno dei seguenti meccanismi:</p>
                <ul>
                    <li>
                        l’esistenza di una decisione di adeguatezza emessa dalla Commissione Europea per il paese in cui vengono trasferiti i Suoi dati personali; o, in
                        alternativa;
                    </li>
                    <li>la conclusione di clausole contrattuali standard che riproducono i modelli adottati dalla Commissione Europea; o, in alternativa;</li>
                    <li>
                        l’esistenza di un’esenzione relativa a una delle situazioni specifiche esaustivamente previste dal Regolamento generale sulla protezione dei dati 2016/679
                        (“GDPR“) (ad esempio, se ha prestato il Suo consenso a tale trasferimento essendo stato informato dell’assenza di garanzie, se il trasferimento è necessario
                        per l’esecuzione di un contratto concluso tra Lei e noi, se il trasferimento è necessario per la conclusione o l’esecuzione di un contratto concluso nel Suo
                        interesse tra noi e un terzo, o se il trasferimento è necessario per stabilire, esercitare o difendere i nostri diritti legali, ecc.).
                    </li>
                </ul>
                <h2>5. PER QUANTO TEMPO CONSERVIAMO I SUOI DATI PERSONALI?</h2>
                <p>
                    Conserviamo i Suoi dati personali non più a lungo di quanto sia necessario per lo scopo del trattamento in questione.
                    <br />
                    <br />
                    In altre parole, ciò significa che i periodi di conservazione che applichiamo variano a seconda dello scopo per il quale trattiamo i dati in questione. La
                    tabella seguente indica quindi, per ogni scopo, il periodo di conservazione che sarà applicato ai Suoi dati personali:
                </p>
                <table>
                    <thead>
                        <tr>
                            <th>FINALITÀ</th>
                            <th>PERSONALIZZAZIONI</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                Registrazione di un account utente con l'implementazione di metodi di autenticazione e autorizzazione sicuri. Ciò include, ad esempio, l'invio di
                                e-mail o messaggi di testo per i protocolli di autenticazione a due fattori;
                            </td>
                            <td>
                                I dati personali forniti nel contesto della registrazione di un account saranno conservati per un periodo di 2 anni dopo l'ultimo tentativo di
                                accesso riuscito.
                            </td>
                        </tr>
                        <tr>
                            <td>Invio automatico di e-mail quando un nuovo studio è disponibile per l'utente in DeepUnity PACSonWEB;</td>
                            <td>
                                I dati personali forniti nel contesto della registrazione di un account saranno conservati per un periodo di 2 anni dopo l'ultimo tentativo di
                                accesso riuscito.
                            </td>
                        </tr>
                        <tr>
                            <td>Tracciabilità dell'accesso registrato alle informazioni mediche;</td>
                            <td>10 anni</td>
                        </tr>
                        <tr>
                            <td>
                                Fornitura dell'elenco degli utenti registrati agli ospedali che utilizzano DeepUnity PACSonWEB per la distribuzione. Questo elenco comprende solo il
                                nome, il cognome e il numero di identificazione del medico (RIZIV, BIG, ...).
                            </td>
                            <td>
                                I dati personali forniti nel contesto della registrazione di un account saranno conservati per un periodo di 2 anni dopo l'ultimo tentativo di
                                accesso riuscito.
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Rispondere alle richieste e alle domande che Lei può presentare attraverso il sito e, più in generale, gestire il nostro rapporto con i visitatori
                                del sito.
                            </td>
                            <td>
                                Rispondere alle richieste e alle domande che Lei può presentare attraverso il sito e, più in generale, gestire il nostro rapporto con i visitatori
                                del sito.
                            </td>
                        </tr>
                        <tr>
                            <td>Conserveremo i Suoi dati personali per un massimo di 2 anni dal nostro ultimo contatto con Lei.</td>
                            <td>Conserveremo i Suoi dati personali per un massimo di 2 anni dal nostro ultimo contatto con Lei.</td>
                        </tr>
                        <tr>
                            <td>Migliorare i nostri servizi e il nostro sito.</td>
                            <td>Migliorare i nostri servizi e il nostro sito.</td>
                        </tr>
                        <tr>
                            <td>
                                Conserveremo i Suoi dati per un massimo di un anno, anche se nella maggior parte dei casi i Suoi dati saranno aggregati poco dopo la raccolta in
                                statistiche non identificabili.
                            </td>
                            <td>
                                Conserveremo i Suoi dati per un massimo di un anno, anche se nella maggior parte dei casi i Suoi dati saranno aggregati poco dopo la raccolta in
                                statistiche non identificabili.
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Invio, con mezzi automatizzati (es. e-mail, SMS, MMS, ecc.) e non (es. telefono, posta ordinaria, ecc.), di messaggi di marketing e di contenuti
                                promozionali relativi alle nostre attività, prodotti e servizi e a quelli delle altre società del gruppo Dedalus (incluse ricerche di mercato,
                                indagini sulla soddisfazione dei clienti, informazioni su webinar ed eventi) (marketing)
                            </td>
                            <td>Tratteremo i suoi dati personali fino alla revoca del suo consenso.</td>
                        </tr>
                        <tr>
                            <td>
                                Trasferimento/Condivisione dei Suoi dati personali con altre società del gruppo Dedalus operanti nel settore biomedico mediante strumenti
                                automatizzati (es. email, SMS, MMS, ecc.) messaggi di marketing e contenuti promozionali relativi alle loro attività, prodotti e servizi (incluse
                                ricerche di mercato, indagini di customer satisfaction, informazioni su webinar ed eventi) (trasferimento di dati a terzi per le loro per finalità
                                di marketing).
                            </td>
                            <td>Tratteremo i suoi dati personali fino alla revoca del suo consenso.</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    In ogni caso, una volta trascorso il periodo di archiviazione applicabile, cancelleremo irrevocabilmente o renderemo anonimi i Suoi dati personali in modo che
                    Lei non possa più essere identificato.
                </p>
                <h2>6. UTILIZZIAMO COOKIE?</h2>
                <p>
                    Utilizziamo i cookie sul nostro sito.
                    <br />
                    Per saperne di più sui cookie che utilizziamo e gli scopi per cui li usiamo, si prega di fare riferimento alla nostra policy sui cookie, che può essere trovata
                    nella sezione Privacy della pagina web.
                </p>
                <h2>7. QUALI SONO I SUOI DIRITTI?</h2>
                <p>
                    In conformità con il quadro giuridico applicabile in materia di protezione dei dati, in particolare con il GDPR, in qualità di interessato dispone dei seguenti
                    diritti:
                    <br />
                    <br />
                    Può richiedere l’accesso ai Suoi dati personali e chiederne la rettifica o la cancellazione.
                    <br />
                    Ha anche il diritto di richiedere che il trattamento dei Suoi dati personali sia limitato o di opporsi allo stesso.
                    <br />
                    Ha il diritto alla portabilità dei Suoi dati personali.
                    <br />
                    Se il trattamento dei Suoi dati personali si basa sul Suo consenso, può revocarlo in qualsiasi momento, senza pregiudicare la liceità del trattamento basato sul
                    consenso prestato antecedentemente alla revoca.
                    <br />
                    Tuttavia, si noti che alcuni dei diritti di cui sopra sono soggetti a condizioni specifiche dettate dal quadro giuridico applicabile in materia di protezione
                    dei dati. Quindi, se la sua situazione specifica non soddisfa tali condizioni, purtroppo non potremo soddisfare la Sua richiesta.
                    <br />
                    <br />
                    Per esercitare i Suoi diritti, La preghiamo di contattare il nostro DPO utilizzando i dati di contatto forniti nella sezione 8 (Come può contattarci?). Per
                    elaborare la Sua richiesta nel modo più efficiente possibile, potremmo chiederLe alcune informazioni aggiuntive per confermare la Sua identità e/o aiutarLa a
                    localizzare i dati personali che costituiscono l’oggetto della Sua richiesta.
                    <br />
                    <br />
                    In ogni caso, Le ricordiamo che può presentare un reclamo all’autorità di controllo competente.
                    <br />
                    <br />
                    In ogni caso, si ricorda che è possibile presentare un reclamo all'Autorità di controllo competente. L'elenco delle autorità preposte alla protezione dei dati è
                    disponibile sul sito :
                    <br />
                    https://ec.europa.eu/justice/article-29/structure/data-protection-authorities/index_en.htm
                </p>
                <h2>8. COME PUÒ CONTATTARCI?</h2>
                <p>
                    Per qualsiasi domanda o richiesta relativa alle operazioni di trattamento dei vostri dati personali da parte nostra ai sensi della presente informativa,
                    compreso l'esercizio dei vostri diritti, come sopra indicato, potete contattarci al seguente indirizzo: info@dobcomed.com.
                    <br />
                    Abbiamo inoltre nominato un responsabile della protezione dei dati ("DPO"), che potete contattare via e-mail al seguente indirizzo:
                    <br />
                    per Dedalus S.p.A. dpo.group@dedalus.eu
                    <br />
                    per Millennium S.r.l. dpo.millennium@dedalus.eu
                    <br />
                    per altre aziende con sede in Italia dpo@dedalus.eu
                    <br />
                    per le aziende con sede nel Regno Unito dpo-uk@dedalus.group.
                    <br />
                    per le aziende con sede in Francia dpo.france@dedalus.eu
                    <br />
                    per le aziende con sede in Germania/Austria e Svizzera dpo.dach@dedalus.com
                    <br />
                    per DH Healthcare GmbH e le altre aziende con sede in belgio dpo.belgium@dedalus.eu
                    <br />
                    per altre aziende dpo.group@dedalus.eu
                </p>
            </>
        );
    }
}
